export const cardStyles = [
  "default",
  "parrot",
  "async-parrot",
  "laptop-parrot",
  "burning-parrot",
  "hypno-parrot",
  // "geib",
  // "sns",
  "zordon",
  "polka",
  "zigzag",
  "psycho"
];
